<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="logo-container">
    <span [ngClass]="{'light-sentinel-one-logo': (theme$ | async) === 'light', 'dark-sentinel-one-logo': (theme$ | async) === 'dark'}" alt="Sentinel One Logo"></span>
</div>
<div class="integration-wrapper" *ngIf="integrationId">
    <form [formGroup]="formGroup">
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{'INTC_API' | translate}}</mat-label>
                <input matInput id="login_url" type="text"formControlName="api_url" placeholder="{{'INTC_API' | translate}}">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{'integrations.sentinel-one.api-token-label' | translate}}</mat-label>
                <input matInput id="username" type="text" formControlName="api_token" placeholder="{{'integrations.sentinel-one.api-token-label' | translate}}">
            </mat-form-field>
        </div>

        <div class="section">
            <mat-radio-group [formControl]="formGroup.controls.lock_option" aria-label="Select what happens when a threat is received.">
                <div>
                    <mat-radio-button value="device_only">{{'INTCB_LOCKA' | translate}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button value="device_sets">{{'INTCB_LOCKB' | translate}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button value="all_devices">{{'INTCB_LOCKC' | translate}}</mat-radio-button>
                </div>
            </mat-radio-group>
        </div>

        <div class="section">
            <mat-checkbox [formControl]="formGroup.controls.admin_unlock" matTooltip="Coming Soon">{{'INTCB_ADMIN' | translate}}</mat-checkbox>
        </div>

        <button type="button" (click)="cancel()" mat-raised-button>{{'CANCEL' | translate}}</button>
        <button type="button" color="primary" (click)="save()" [disabled]="!formGroup.valid" mat-raised-button>{{'SAVE' | translate}}</button>
        <button type="button" color="accent" (click)="validate()" [disabled]="!formGroup.valid" mat-raised-button>{{'INTCB_VALIDATE' | translate}}</button>

    </form>
</div>
